import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { User } from '@domain/interface/user';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { SharedService } from '@service/shared/shared.service';
import { UtilService } from '@service/util/util.service';
import { UserRoleService } from '@service/userRole/user-role.service';
import { TEMPLATE_TYPE } from '@domain/constants/email-templates';

@Component({
	selector: 'app-sidenav-menu',
	templateUrl: './sidenav-menu.component.html',
	styleUrls: ['./sidenav-menu.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class SidenavMenuComponent implements OnInit {
	options: UntypedFormGroup;
	user: User;

	opened = true;
	over = 'side';
	expandHeight = '42px';
	collapseHeight = '42px';
	displayMode = 'flat';

	TEMPLATE_TYPE = TEMPLATE_TYPE;

	constructor(
		fb: UntypedFormBuilder,
		private sharedService: SharedService,
		public cargochief: Cargochief,
		public utilService: UtilService,
		public userRoleService: UserRoleService
	) {
		this.options = fb.group({
			fixed: false,
			top: 0,
			bottom: 0,
		});
		this.utilService.isNullOrUndefined;
	}

	ngOnInit() {
		this.user = this.cargochief.getUser();
		this.sharedService.getLayoutToggledValue().subscribe((data) => {
			this.opened = data;
		});
	}
}
